import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from './button.js';
import { cn } from './cn.js';
export function InputGroup({ className, ...props }) {
    return _jsx("div", { className: cn('relative', className), ...props });
}
/**
 * The trailing action of a field-with-button pair, fused to the field as
 * ONE block (the email test send's recipient + Send).
 *
 * Wiring: the group takes `flex`, the input `flex-1 rounded-r-none`, and
 * this button supplies `rounded-l-none` plus the `field` height so the two
 * halves share a seam and a 40px rhythm. `shrink-0` keeps a long value
 * from squeezing the action.
 */
export function InputGroupButton({ className, size = 'field', ...props }) {
    return (_jsx(Button, { size: size, className: cn('shrink-0 rounded-l-none', className), ...props }));
}
export function InputGroupAddon({ align = 'inline-start', className, ...props }) {
    return (_jsx("div", { "data-align": align, className: cn('pointer-events-none absolute top-1/2 flex -translate-y-1/2 items-center text-text-faint', align === 'inline-start' ? 'left-3' : 'right-3', className), ...props }));
}
//# sourceMappingURL=input-group.js.map